var domReady = function(callback) {
  document.readyState === "interactive" || document.readyState === "complete" ? callback() : document.addEventListener("DOMContentLoaded", callback);
};

// IE 'forEach' POLYFILL
(function () {
  if ( typeof NodeList.prototype.forEach === "function" ) return false;
  NodeList.prototype.forEach = Array.prototype.forEach;
})();

var mobileBrowser = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent),
    URL_REGEXP = /^((?:http|ftp)s?:\/\/|)(?:(?:[A-Z0-9](?:[A-Z0-9-]{0,61}[A-Z0-9])?\.)+(?:[A-Z]{2,6}\.?|[A-Z0-9-]{2,}\.?)|localhost|\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})(?::\d+)?(?:\/?|[\/?]\S+)$/i;


// REPLACE MULTIPLE TEXT VALUES
String.prototype.allReplace = function(obj) {
  var retStr = this;
  for (var x in obj) {
    retStr = retStr.replace(new RegExp(x, 'g'), obj[x]);
  }
  return retStr;
};

// UPDATE URL
var updateURL = function(prm, val) {
  if (history.pushState) {
    var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + prm + '=' + val;
    window.history.pushState({path:newurl},'',newurl);
  }
}

// UPDATE OF:URL
var updateOgURL = function(url) {
  document.getElementsByTagName('meta')['ogurl'].content = url;
}
var updateOgTitle = function(cont) {
  document.getElementsByTagName('meta')['ogtitle'].content = cont;
}

// UPDATE OG:TITLE
var updateOgTitle = function(cont) {
  document.getElementsByTagName('meta')['ogtitle'].content = cont;
}


domReady(function() {

  if (mobileBrowser) {
    document.body.classList.add('is-mobile');
  }
  
  var mainCont = document.querySelector('.MainContent'),
  		inp = document.getElementById('InputTitle'),
  		minChrs = 30,
  		// chrsLft = document.querySelector('.CharsLeft'),
  		cvrtBtn = document.querySelector('.ConvertBtn'),
      cvrtAgnBtn = document.querySelector('.ConvertAgainBtn'),
  		rsl = document.querySelector('.Result'),
      rslPrfx = document.querySelector('.Result-prefix'),
      rslTtl = document.querySelector('.Result-title'),
  		wrn = document.querySelector('.Warning'),
  		prfx,
      newPrfx;

  // GET PREFIXES FROM JSON
  var requestURL = 'js/prefixes.json',
      request = new XMLHttpRequest();
  request.open('GET', requestURL);
  request.responseType = 'json';
  request.send();

  request.onload = function() {
    prfx = request.response;
  }

  // Begin of: ALTERATIONS FUNCTIONS
  // --------------------------------------------------

  // ALTERATE TEXT
  var alterateText = function(textToAnalize) {
    var txtrplc = {
                  // letters
                  'î':'â',
                  // hyphens
                  's-a':'sa', 'l-a':'la',
                  // words
                  'pe':'pă', 'doar':'decît', 'care':'pă care', 'copiii':'copi', 'copii':'copi',
                  // bad/banned words
                  'pula':'cocoșelul', 'pulă':'cocoșel', 'pizda':'păsărica', 'pizdă':'păsărică', 'muie':'sex oral'};
        textToAnalize = inp.value;
    return textToAnalize.allReplace(txtrplc);
  }
  
  // --------------------------------------------------
  // End of: ALTERATIONS FUNCTIONS

  // ADD FUNNY PREFIX
  var addPrfx = function() {
    var newNo = Math.floor(Math.random()*prfx.length);
    newPrfx  =  prfx[newNo];
    prfx.splice(newNo, 1);
    rslPrfx.innerHTML = newPrfx.toUpperCase() + '!';
  }

  // ADD UPDATED TITLE
  var addTtl = function() {
    var finalTtl = alterateText(inp.value);
    rslTtl.innerHTML = finalTtl;
    updateURL('prfx', newPrfx.replace(/\s+/g, '_') + '!&ttl=' + finalTtl.replace(/\s+/g, '_'));
    updateOgURL(window.location.href);
    document.title = newPrfx + '! ' + finalTtl;
    updateOgTitle(newPrfx + '! ' + finalTtl);
  }

  // addTtl();

  // COUNT CLICKS
  var updateCounter = function() {
    var xmlhttp;
    if (window.XMLHttpRequest) {
      // code for IE7+, Firefox, Chrome, Opera, Safari
      xmlhttp=new XMLHttpRequest();
    } else {
      // code for IE6, IE5
      xmlhttp=new ActiveXObject("Microsoft.XMLHTTP");
    }
    xmlhttp.open("POST","update.php",true);
    xmlhttp.setRequestHeader("Content-type","application/x-www-form-urlencoded");
    xmlhttp.onreadystatechange = function() {
      document.querySelector('.Counter-clicks').innerHTML = xmlhttp.responseText;
    }
    xmlhttp.send("doit=true");
  }

  // GET URL
  var getURL = function() {
    var url_string = window.location.href,
        url = new URL(url_string),
        p = url.searchParams.get('prfx'),
        t = url.searchParams.get('ttl');
    if(p || t) {
      // console.log(p.replace(/_/g, " "));
      rsl.innerHTML = '<span class="Result-prefix-wrapper"><span class="Result-prefix">' + p.replace(/_/g, " ").toUpperCase() + '</span></span><span class="Result-title">' + t.replace(/_/g, " ") + '</span>';
      updateURL('prfx', p + '&ttl=' + t);
      updateOgURL(window.location.href);
      document.title = p.replace(/_/g, " ") + '! ' + t.replace(/_/g, " ");
      updateOgTitle(p.replace(/_/g, " ") + '! ' + t.replace(/_/g, " "));
      // updateCounter();
      mainCont.classList.add('is-converted');
    }
  }
  getURL();

  // SHOW WARNING
  var showWarning = function(msg) {
  	wrn.innerHTML = msg;
  }

  // HIDE WARNING
  var hideWarning = function(msg) {
    wrn.innerHTML = '';
  }

  // MODALS
  var enableModal = function(btn, mdl) {
    var mdlBtn = document.querySelector(btn),
        mdlItem = document.querySelector(mdl),
        mdlClsBtn = mdlItem.querySelector('.Modal-closeBtn');
    mdlBtn.addEventListener('click', function() {
      mdlItem.classList.add('is-visible');
    })
    mdlClsBtn.addEventListener('click', function() {
      mdlItem.classList.remove('is-visible');
    })
  }

  enableModal('.ShareBtn', '.ShareModal');

  // COUNT TEXTAREA CHARACTERS
  // inp.addEventListener('keyup', function() {
  // 	chrsLft.innerHTML = "Characters left: " + (minChrs - this.value.length);
  // });

  cvrtBtn.addEventListener('click', function(e) {
  	e.preventDefault();
  	if(prfx.length > 0) {
	  	if(inp.value.length > minChrs) {
	  		mainCont.classList.add('is-converting');
        hideWarning();
        addPrfx();
        addTtl();
        setTimeout(function() {
          mainCont.classList.add('is-converted');
          // mainCont.classList.remove('is-converting');
          updateCounter();
          setTimeout(function() {
            mainCont.classList.remove('is-converting');
          }, 500);
        }, 3500);
	  	} else if (inp.value.match('ASDASD') != null || inp.value.match('asdasd') != null) {
	  		showWarning(('"asdasd" ești tu cu prietenii tăi! Scrie un titlu normal!'));
	  	} else {
	  		showWarning(('Scrie un titlu mai lung (minim ' + minChrs + ' caractere).'));
	  	}
	  } else {
	  	mainCont.classList.add('is-final');
	  }
  });

  cvrtAgnBtn.addEventListener('click', function(e) {
    e.preventDefault();
    if(prfx.length > 0) {
      mainCont.classList.remove('is-converted');
    } else {
      mainCont.classList.add('is-final');
    }
  });

  

  setTimeout(function() {
    inp.focus();
  }, 0);


  // GENERATE AND DOWNLOAD IMAGE
  var ttlCapt = document.querySelector('.Result-wrapper'),
      dwnlImgBtn = document.querySelector('.GetImageBtn'),
      dwnlImgLnk = document.createElement('a');

  dwnlImgLnk.download = 'titloo.jpeg';
  document.body.appendChild(dwnlImgLnk);

  dwnlImgBtn.addEventListener('click', function(e) {
    domtoimage.toJpeg(ttlCapt, {
      quality: 1,
      cacheBust: true
    })
      .then(function (dataUrl) {
        dwnlImgLnk.href = dataUrl;
        dwnlImgLnk.click();
        dwnlImgLnk.href = '';
      });
  });
  
});


// !!! update og metas pentru share pe fb
// Alterează 's-a', 'ți', etc.
// share -> adaugă link către articolul original -> load it in iframe below the joke
// create single json file with all prefixes and alterations